module.exports = __webpack_public_path__ + "img/play_1.a9cb4dee.png";